/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export const UploadStatus = {
        NOT_UPLOADED: 'not_uploaded',
        IN_MODAL_DIALOG: 'in_modal_dialog',
        UPLOADED: 'uploaded'
} as const;
export type UploadStatus = typeof UploadStatus[keyof typeof UploadStatus];

